import { endpoints } from "constant";

export const stagesUrlBuilder = {
  getStages: function (study?: string): string {
    const queryString = study ? `?study=${study}` : "/";
    return `${endpoints.stages}${queryString}`;
  },
};
